import { EngagementBuyerActionState } from '../models/engagement-buyer-action-state.model';
import { TimelineEventStatus } from '../models/enums/timeline-event-status.enum';
import { TimelineActionType } from '../models/timeline-action-type.model';
import { TimelineEvent } from '../models/timeline-event.model';

// #943: the buyer's range submissions on range-of-value events positioned before the given one
// in the timeline order (upcoming events excluded), newest first by dateCreated. Used to carry
// an assumed-unchanged range forward once an event closes without an update, and to show the
// range history in the cell tooltip.
export const getEarlierValueRanges = (
    event: TimelineEvent,
    allEvents: TimelineEvent[],
    actionStates: EngagementBuyerActionState[] | undefined
): EngagementBuyerActionState[] => {
    const eventIndex = allEvents.findIndex((e) => e.id === event.id);
    const earlierRangeActionIds = allEvents
        .filter(
            (e, index) =>
                index < eventIndex &&
                e.linkedAction?.actionType ===
                    TimelineActionType.BuyerExpressionOfInterestWithRange &&
                e.status !== TimelineEventStatus.Upcoming
        )
        .map((e) => e.linkedAction.id);

    return (actionStates ?? [])
        .filter(
            (x) =>
                earlierRangeActionIds.includes(x.actionId) &&
                x.minPrice &&
                x.maxPrice
        )
        .sort(
            (a, b) =>
                new Date(b.dateCreated).getTime() -
                new Date(a.dateCreated).getTime()
        );
};

// The latest earlier range (range assumed unchanged) or null when the buyer never provided one.
export const getCarriedForwardValueRange = (
    event: TimelineEvent,
    allEvents: TimelineEvent[],
    actionStates: EngagementBuyerActionState[] | undefined
): EngagementBuyerActionState | null =>
    getEarlierValueRanges(event, allEvents, actionStates)[0] ?? null;
